import { LayoutGrid, CalendarDays, CalendarRange } from 'lucide-react';
import { clsx } from 'clsx';
import { useUIStore } from '@/stores';
import type { PageKey } from '@/stores/uiStore';

type ViewMode = 'card' | 'weekly' | 'monthly';

interface ViewSwitcherProps {
  pageKey: PageKey;
  modes?: ViewMode[];
}

const modeConfig: Record<ViewMode, { icon: typeof LayoutGrid; label: string }> = {
  card: { icon: LayoutGrid, label: 'Card view' },
  weekly: { icon: CalendarDays, label: 'Weekly view' },
  monthly: { icon: CalendarRange, label: 'Monthly view' },
};

export function ViewSwitcher({ pageKey, modes = ['card', 'weekly', 'monthly'] }: ViewSwitcherProps) {
  const { viewMode, setViewMode } = useUIStore();
  const currentMode = viewMode[pageKey];

  return (
    <div className="flex rounded-lg border border-gray-300 overflow-hidden">
      {modes.map((mode) => {
        const config = modeConfig[mode];
        const Icon = config.icon;
        const isActive = currentMode === mode;

        return (
          <button
            key={mode}
            onClick={() => setViewMode(pageKey, mode)}
            className={clsx(
              'p-2 transition-colors',
              isActive
                ? 'bg-primary-600 text-white'
                : 'bg-white text-gray-500 hover:bg-gray-50 hover:text-gray-700'
            )}
            title={config.label}
          >
            <Icon className="h-4 w-4" />
          </button>
        );
      })}
    </div>
  );
}
